<template>
  <div class="contact-container">
    <div class="contact__inner">
      <div class="contact__text-container">
        <div class="text__up-container">
          <div class="text__item" v-if="address">
            <div class="item__row">
              <p>{{ address.info.contact_key }}</p>
              <p>{{ address.info.contact_val }}</p>
            </div>
          </div>
          <div
            class="text__item"
            :style="{
              borderColor: lineColor['0']
            }"
            v-if="emails.length > 0"
          >
            <div class="item__row" v-for="(email, index) in emails" :key="index">
              <p>{{ email.info.contact_key }}</p>
              <p>
                {{ email.info.contact_val }}
              </p>
            </div>
          </div>
          <div
            class="text__item"
            :style="{
              borderColor: lineColor['1']
            }"
            v-if="tel"
          >
            <div class="item__row">
              <p>{{ tel.info.contact_key }}</p>
              <p>{{ tel.info.contact_val }}</p>
            </div>
          </div>
        </div>
        <div class="text__down-container">
          <div class="title">WeChat Public Platform</div>
          <div class="qr-box">
            <img src="@/assets/images/qr.png" alt="" />
          </div>
        </div>
      </div>
      <div class="contact__imgs-container">
        <div class="imgs__swiper-container">
          <swiper class="swiper__wrapper" ref="homeSwiper" :options="swiperOptions">
            <swiper-slide class="swiper__slide-item" v-for="(item, index) in slides" :key="index">
              <img
                :src="$bowser.mobile ? item.src.mobile : item.src.pc"
                alt=""
                class="item__img-box"
              />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { slides, cinfo } from '@/utils/data';

const colors = ['#00a69b', '#c3d714', '#f8b61c', '#ae027e'];
const swiperSpeed = 2000;
export default {
  name: 'page-contact',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      slides: [],
      swiperOptions: {
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        effect: 'fade',
        loop: true,
        speed: swiperSpeed,
      },
      infos: null,
    };
  },
  computed: {
    lineColor() {
      const temp = colors;
      const data = [];
      for (let i = 0; i < 2; i += 1) {
        const c = Math.floor(Math.random() * (temp.length - i));
        data.push(temp[c]);
        temp[c] = temp[temp.length - i - 1];
      }
      return data;
    },
    address() {
      return this.infos ? this.infos.address : null;
    },
    emails() {
      return this.infos ? this.infos.emails : [];
    },
    tel() {
      return this.infos ? this.infos.tel : null;
    },
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    Promise.all([slides('contact'), cinfo()]).then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  methods: {
    setData(data) {
      this.slides = data['0'];
      this.infos = data['1'];
    },
  },
};
</script>

<style></style>
